module.exports = __webpack_public_path__ + "static/media/analogue.dcf48656.jpg";